import {memo} from 'react';
import {CircularLoader} from '../circular-loader';
import {cn} from '../lib/cn';

export interface ModalLoaderProps {
  visible?: boolean;
  className?: string;
}

export const ModalLoader = memo(({visible, className}: ModalLoaderProps) => (
  <div
    className={cn(
      'absolute left-0 top-0 !m-0 h-full w-full items-center justify-center rounded-[var(--dialog-content-radius)] bg-[var(--chekin-color-white)] opacity-70',
      visible ? 'flex' : 'hidden',
      className,
    )}
  >
    <div className="mb-[60px]">
      <CircularLoader size="lg" className="[--circular-loader-color:#475569]" />
    </div>
  </div>
));

ModalLoader.displayName = 'ModalLoader';
